import { ALL_APP_IDS, ALL_APPS, ALL_VIEW_IDS } from 'constants/appConstants';
import MainCardWrapper from 'layout/MainLayout/MainCardWrapper';
import PermissionsRouteWrapper from 'views/pages/components/PermissionsRouteWrapper';
import Loadable from 'ui-component/Loadable';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import NoSubOrgRouteWrapper from 'views/pages/components/NoSubOrgRouteWrapper';
import ViewTabs from 'layout/MainLayout/ViewTabs';

const BillingInvoices = Loadable(lazy(() => import('views/billing/invoices')));
const BillingUsage = Loadable(lazy(() => import('views/billing/usage')));
const BillingPayments = Loadable(lazy(() => import('views/billing/payments')));

export const BillingRoutes = [
  {
    path: `${ALL_APPS.BILLING.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.BILLING.id,
          view: ALL_VIEW_IDS.BILLING_USAGE,
        }}
      >
        <Navigate
          to={`${ALL_APPS.BILLING.views?.BILLING_USAGE?.path}`}
          replace
        />
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.BILLING.views?.BILLING_USAGE?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.BILLING.id,
          view: ALL_VIEW_IDS.BILLING_USAGE,
        }}
      >
        <>
          <ViewTabs appId={ALL_APP_IDS.BILLING} />
          <NoSubOrgRouteWrapper>
            <BillingUsage />
          </NoSubOrgRouteWrapper>
        </>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.BILLING.views?.BILLING_INVOICES?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.BILLING.id,
          view: ALL_VIEW_IDS.BILLING_INVOICES,
        }}
      >
        <>
          <ViewTabs appId={ALL_APP_IDS.BILLING} />
          <MainCardWrapper>
            <NoSubOrgRouteWrapper>
              <BillingInvoices />
            </NoSubOrgRouteWrapper>
          </MainCardWrapper>
        </>
      </PermissionsRouteWrapper>
    ),
  },
  {
    path: `${ALL_APPS.BILLING.views?.BILLING_PAYMENTS?.path}`,
    element: (
      <PermissionsRouteWrapper
        permissionScope={{
          app: ALL_APPS.BILLING.id,
          view: ALL_VIEW_IDS.BILLING_PAYMENTS,
        }}
      >
        <>
          <ViewTabs appId={ALL_APP_IDS.BILLING} />
          <NoSubOrgRouteWrapper>
            <BillingPayments />
          </NoSubOrgRouteWrapper>
        </>
      </PermissionsRouteWrapper>
    ),
  },
];
